import longTermLeaseCommentRequests from 'app/requests/LongTermLease/LongTermLeaseComment.requests'
import CommentsLog from 'app/shared-components/CommentsLog'
import useGetLongTermLeaseComments from './hooks/useGetLongTermLeaseComments'
import useRemoveTermLeaseComment from './hooks/useRemoveTermLeaseComment'

const LongTermLeaseComments = ({
    longTermLeaseId,
}: {
    longTermLeaseId: number,
}) => {
    const {
        onParamsChange,
        loadData,
        refetch,
    } = useGetLongTermLeaseComments(longTermLeaseId)

    const deleteComment = useRemoveTermLeaseComment({
        onSuccess: refetch,
    })

    return (
        <CommentsLog
            requestConfigCreate={longTermLeaseCommentRequests.create({
                longTermLeaseId,
            })}
            deleteComment={deleteComment}
            onParamsChange={onParamsChange}
            loadData={loadData}
            refetch={refetch}
            sorting={false}
        />
    )
}

export default LongTermLeaseComments
